<div class="dialog-container">
<h1 mat-dialog-title>{{ "Header.SaveAs" | translate }}</h1>   
<div mag-dialog-content>
  <mat-form-field>
    <input #FilterProfileName matInput type="text" placeholder="'{{ 'Header.FilterProfileName' | translate }}" [(ngModel)]="data.profileName" required />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="secondary" siteUsageTracker [logCategory]="'FilterProfile'" [logName]="'saveFilterProfileDialogCancel'" (click)="cancel()">{{ "Header.Cancel" | translate }}</button>
  <button mat-raised-button
          class="mat-elevation-z1"
          color="primary"
          [mat-dialog-close]="data.profileName"
          siteUsageTracker [logCategory]="'FilterProfile'" [logName]="'saveFilterProfileDialogSave'"
          (click)="save()"
          [disabled]="!data.profileName">
    {{ "Header.Save" | translate }}
  </button>
</div>
</div>